module.exports = __webpack_public_path__ + "img/bg_avatar_female_55.2e2a5aec.png";